<script lang="ts" setup>
import TrainingModal from "./TrainingModal.vue";
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import TrainingModalExit from "./TrainingModalExit.vue";

const createTrainingStore = useCreateTrainingStore();
const emit = defineEmits(["reset"]);
</script>

<template>
  <TrainingModal v-if="createTrainingStore.showModal" @reset="emit('reset')"></TrainingModal>
  <TrainingModalExit v-if="createTrainingStore.showExit"></TrainingModalExit>
</template>
